import React, { useMemo } from "react"
import { formatAmount, getTableSortingHeaderIcon } from "helpers/common"
import { Link } from "react-router-dom"
import moment from "moment"
import eye from "../../../assets/images/icons/eye.svg"
import TableContainer from "components/Common/TableContainer"
import { useSelector } from "react-redux"

const defaultFilters = {
  page: 1,
  pageSize: 20,
}

export default function IcdByAdmin({ data, close }) {
  const { userType } = useSelector((state) => state.user)

  const columns = useMemo(
    () => [
      {
        header: ({ column }) =>
          getTableSortingHeaderIcon(column, " Request ID"),
        accessorKey: "unique_code",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => <div className="">{row?.original.unique_code}</div>,
      },

      {
        header: ({ column }) =>
          getTableSortingHeaderIcon(column, " Amount (₹)"),
        accessorKey: "amount",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => <div>₹ {formatAmount(row?.original.amount)}</div>,
      },
      {
        header: ({ column }) => getTableSortingHeaderIcon(column, " Interest"),
        accessorKey: "interest_rate",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div className="">{row?.original.interest_rate} %</div>
        ),
      },
      {
        header: ({ column }) =>
          getTableSortingHeaderIcon(column, "Date of Repayment"),
        accessorKey: "repayment_date",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div className="">
            {row?.original.repayment_date
              ? moment(row?.original.repayment_date).format("D MMM YYYY")
              : ""}
          </div>
        ),
      },
      {
        header: ({ column }) =>
          getTableSortingHeaderIcon(column, " Fund Availability Date"),
        accessorKey: "fund_requirement_date",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <>
            {moment(row?.original.fund_requirement_date).format("D MMM YYYY")}
          </>
        ),
      },
      {
        id: "action",
        header: "Actions",
        cell: ({ row }) => (
          <div className="d-flex justify-content-center align-items-center gap-3">
            <div className="action-view">
              <Link
                to={
                  userType === "INVESTOR"
                    ? `/icd-investments/fund-requests`
                    : `/investment-management/fund-requirements`
                }
                onClick={close}
              >
                <img src={eye} alt="" />
              </Link>
            </div>
          </div>
        ),
      },
    ],
    []
  )

  return (
    <>
      <TableContainer
        title={"Icd investments by Admin"}
        filters={defaultFilters}
        columns={columns}
        data={data}
        isCustomPageSize={false}
        isPagination={false}
        pagination="pagination"
        paginationWrapper="dataTables_paginate paging_simple_numbers"
        tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
      />
    </>
  )
}
